// extracted by mini-css-extract-plugin
module.exports = {"toggle":"styles_toggle__2AOUZ","toggle_label":"styles_toggle_label__1yGkv","form":"styles_form__6_gIa","price":"styles_price__3H8KY"};